module.exports = __webpack_public_path__ + "img/appstore.c85de657.svg";